import React, { useEffect, useState } from 'react';
import { Link, NavLink, Outlet, useNavigate, Navigate } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, Building2, UtensilsCrossed, Tag, Clock, ShoppingCart, LogOut, ExternalLink, Menu, SlidersHorizontal, Layers, Users, Image as ImageIcon, ChefHat, Printer } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { LOGO_MARK } from '../../mock';

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const links = [
    { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
    { to: '/admin/messages', label: 'Contact Messages', icon: MessageSquare },
    { to: '/admin/franchise', label: 'Franchise Inquiries', icon: Building2 },
    { to: '/admin/menu', label: 'Menu Items', icon: UtensilsCrossed },
    { to: '/admin/categories', label: 'Categories', icon: Layers },
    { to: '/admin/modifiers', label: 'Modifiers', icon: SlidersHorizontal },
    { to: '/admin/deals', label: 'Deals', icon: Tag },
    { to: '/admin/hours', label: 'Opening Hours', icon: Clock },
    { to: '/admin/orders', label: 'Orders', icon: ShoppingCart },
    { to: '/admin/kitchen', label: 'Kitchen Board', icon: ChefHat },
    { to: '/admin/printer', label: 'Receipt Printer', icon: Printer },
    { to: '/admin/customers', label: 'Customers & Rewards', icon: Users },
    { to: '/admin/settings', label: 'Site Images', icon: ImageIcon },
  ];

  return (
    <div className="min-h-screen bg-[#F7F5F2]">
      <header className="bg-white border-b border-gray-100 sticky top-0 z-30">
        <div className="px-4 md:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button onClick={() => setOpen(!open)} className="lg:hidden p-2"><Menu size={22} /></button>
            <Link to="/admin" className="flex items-center"><img src={LOGO_MARK} alt="Wrappus" className="h-11 w-auto" /></Link>
            <span className="hidden md:inline text-xs uppercase tracking-widest text-gray-400">Admin</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-sm text-gray-600 hover:text-[#ED2E2E] flex items-center gap-1"><ExternalLink size={14} /> View site</Link>
            <span className="text-sm text-gray-600 hidden sm:inline">{user.email}</span>
            <button onClick={() => { logout(); nav('/admin/login'); }} className="flex items-center gap-2 text-sm text-gray-600 hover:text-[#ED2E2E]"><LogOut size={16} /> Logout</button>
          </div>
        </div>
      </header>

      <div className="flex">
        <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-white border-r border-gray-100 transform transition-transform lg:translate-x-0 ${open ? 'translate-x-0' : '-translate-x-full'}`} style={{ top: 64, height: 'calc(100vh - 64px)' }}>
          <nav className="p-4 space-y-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.end} onClick={() => setOpen(false)} className={({ isActive }) => `flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors ${isActive ? 'bg-[#ED2E2E] text-white' : 'text-[#0F1C2E] hover:bg-[#FDF3EC]'}`}>
                <l.icon size={18} /> {l.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <main className="flex-1 p-6 lg:p-10 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
